import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { adminGuard } from './core/admin.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
    title: 'Dashboard - xRLive',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
        title: 'Dashboard - Home',
        data: { breadcrumb: 'Dashboard' }
      },
      {
        path: 'billing',
        loadComponent: () => import('./pages/billing/billing.component').then(m => m.BillingComponent),
        title: 'Billing - xRLive',
        data: { breadcrumb: 'Billing' }
      },
      {
        path: 'my-visuals',
        loadComponent: () => import('./pages/my-visuals/my-visuals.component').then(m => m.MyVisualsComponent),
        title: 'My Library - xRLive',
        data: { breadcrumb: 'My Library' }
      },
      {
        path: 'products',
        redirectTo: '/dashboard/marketplace',
        pathMatch: 'full'
      },
      {
        path: 'sales',
        loadComponent: () => import('./pages/sales/sales.component').then(m => m.SalesComponent),
        title: 'Sales - xRLive',
        data: { breadcrumb: 'Sales' }
      },
      {
        path: 'marketplace',
        loadComponent: () => import('./pages/marketplace/marketplace.component').then(m => m.MarketplaceComponent),
        title: 'Marketplace - xRLive',
        data: { breadcrumb: 'Marketplace' }
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/settings/settings.component').then(m => m.SettingsComponent),
        title: 'Configuration - xRLive',
        data: { breadcrumb: 'Configuration' }
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
        title: 'Profile - xRLive',
        data: { breadcrumb: 'Profile' }
      },
      {
        path: 'notifications/:id',
        loadComponent: () => import('./pages/notifications/notification-detail.component').then(m => m.NotificationDetailComponent),
        title: 'Notification - xRLive',
        data: { breadcrumb: 'Notification' }
      },
      {
        path: 'notifications',
        loadComponent: () => import('./pages/notifications/notifications.component').then(m => m.NotificationsComponent),
        title: 'Notifications - xRLive',
        data: { breadcrumb: 'Notifications' }
      },
      {
        path: 'licenses',
        loadComponent: () => import('./pages/licenses/licenses.component').then(m => m.LicensesComponent),
        title: 'Licenses - xRLive',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Licenses' }
      },
      {
        path: 'licenses/:licenceId',
        loadComponent: () => import('./pages/licenses/licence-detail.component').then(m => m.LicenceDetailComponent),
        title: 'Licence Detail - xRLive',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Licence Detail' }
      },
      {
        path: 'admin/users',
        loadComponent: () => import('./pages/admin-users/admin-users.component').then(m => m.AdminUsersComponent),
        title: 'Users - xRLive',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Users' }
      },
      {
        path: 'admin/users/:userId',
        loadComponent: () => import('./pages/admin-users/admin-user-detail.component').then(m => m.AdminUserDetailComponent),
        title: 'User Detail - xRLive',
        canActivate: [adminGuard],
        data: { breadcrumb: 'User Detail' }
      },
      {
        path: 'team',
        loadComponent: () => import('./pages/team/team.component').then(m => m.TeamComponent),
        title: 'Team - xRLive',
        data: { breadcrumb: 'Team' }
      },
      {
        path: 'admin/orgs',
        loadComponent: () => import('./pages/admin-orgs/admin-orgs.component').then(m => m.AdminOrgsComponent),
        title: 'Organizations - xRLive',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Organizations' }
      },
      {
        path: 'admin/orgs/:orgId',
        loadComponent: () => import('./pages/admin-orgs/admin-org-detail.component').then(m => m.AdminOrgDetailComponent),
        title: 'Organization - xRLive',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Organization' }
      },
      {
        path: 'admin/software',
        loadComponent: () => import('./pages/software/software.component').then(m => m.SoftwareComponent),
        title: 'Software Updates - xRLive',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Software' }
      },
      {
        path: 'admin/visual-review',
        loadComponent: () => import('./pages/admin-visual-review/admin-visual-review.component').then(m => m.AdminVisualReviewComponent),
        title: 'Visual Review - xRLive',
        canActivate: [adminGuard],
        data: { breadcrumb: 'Visual Review' }
      }
    ]
  },
  {
    path: 'signin',
    loadComponent: () => import('./pages/auth/signin.component').then(m => m.SigninComponent),
    title: 'Sign In - xRLive'
  },
  {
    path: 'oauth/callback',
    loadComponent: () => import('./pages/auth/oauth-callback.component').then(m => m.OAuthCallbackComponent),
    title: 'Signing you in...'
  },
  {
    path: 'signup',
    loadComponent: () => import('./pages/auth/signup.component').then(m => m.SignupComponent),
    title: 'Sign Up - xRLive'
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/auth/forgot-password.component').then(m => m.ForgotPasswordComponent),
    title: 'Forgot Password - xRLive'
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/auth/reset-password.component').then(m => m.ResetPasswordComponent),
    title: 'Reset Password - xRLive'
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
